<script setup lang="ts">
import { getTranslatedAiSearchSamplePrompt } from '@@/bits/content_picker'
import { __ } from '@@/bits/intl'
import { SearchFilters } from '@@/bits/web_search'
import OzContainedButton, {
  OzContainedButtonColorScheme,
  OzContainedButtonSizePreset,
} from '@@/library/v4/components/OzContainedButton.vue'
import { useContentPickerStore } from '@@/pinia/content_picker'
import { processedUrl } from '@padlet/vivaldi-client'

const emit = defineEmits<{
  (name: 'run-sample-search', payload: { searchQuery: string }): void
}>()

const { setSearchQuery, search, pickSearchFilter } = useContentPickerStore()

const searchForSample = (): void => {
  setSearchQuery({ query: getTranslatedAiSearchSamplePrompt() })
  pickSearchFilter({ filter: SearchFilters.AiImages })
  search()
  emit('run-sample-search', { searchQuery: getTranslatedAiSearchSamplePrompt() })
}
</script>

<template>
  <div class="h-109 flex flex-col items-center justify-center">
    <div>
      <img
        :src="processedUrl('https://storage.googleapis.com/padlet-assets/image/basketball_nebula.webp')"
        width="240"
        height="240"
        :alt="getTranslatedAiSearchSamplePrompt()"
        class="select-none rounded-lg"
      />
    </div>
    <div>
      <p
        class="py-3 w-71 text-center text-body-extra-small text-dark-text-100 dark:text-light-text-100 px-4 select-text"
      >
        "{{ getTranslatedAiSearchSamplePrompt() }}"
      </p>
    </div>
    <div>
      <OzContainedButton
        class="mb-10"
        :size-preset="OzContainedButtonSizePreset.H24px"
        :color-scheme="OzContainedButtonColorScheme.Secondary"
        :text="__('Try this example')"
        data-pw="aiImageSearchSample"
        @click="searchForSample"
      />
    </div>
  </div>
</template>
